// extracted by mini-css-extract-plugin
module.exports = {"section":"OnePictureV2_section__G1oGy"};